@if (show()) {
  <div
    role="status"
    class="flex items-center justify-between gap-4 px-4 py-2 bg-warning/10 border-b border-warning/30 text-sm"
  >
    <span class="text-dark-text-secondary">
      {{ 'auth.verifyEmailBanner' | transloco }}
    </span>
    <a
      routerLink="/auth/verify-email"
      class="shrink-0 font-semibold text-dark-accent hover:text-dark-accent-hover transition-colors"
    >
      {{ 'auth.verifyNow' | transloco }}
    </a>
  </div>
}
